import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-red",
  "use": "icon-play-red-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play-red\"><path d=\"M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z m0 0\" fill=\"#DC0000\" /><path d=\"M445.44 683.52c-30.72 17.92-56.32 2.56-56.32-30.72V371.2c0-35.84 25.6-48.64 56.32-30.72l238.08 140.8c30.72 17.92 30.72 46.08 0 64L445.44 683.52z m0 0\" fill=\"#FFFFFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/play-red.svg
// module id = 7PX8
// module chunks = 65